var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { action, computed, makeObservable } from 'mobx';
import { runtime } from '../../../../runtime/Runtime';
export class MedFileInfo {
    parent;
    constructor(parent) {
        makeObservable(this);
        this.parent = parent;
    }
    get medFile() {
        return this.parent;
    }
    get readableCreationDate() {
        return this.medFile.medFileSource.mediumCreationDate.mysqlTimestamp;
    }
    /** Do not use directly as not reliably available */
    get derivedExtensionFromFilename() {
        const pieces = this.medFile.filePath.split('.');
        return (pieces[pieces.length - 1] || '').split('?')[0];
    }
    /** Do not use as not reliably available */
    get base64Extension() {
        const p1 = this.medFile.base64.split(';')[0].split('/');
        return (p1.length > 1 ? p1[1] : '');
    }
    get nativeUrl() {
        if (!this.medFile.context.app)
            return '';
        return `${this.medFile.context.app.appHost.nodeHref + this.medFile.filePath}?version=${this.medFile.fileVersion}`;
    }
    detectFileSize() {
        if (!runtime.isBrowserRuntime)
            return;
        console.log('detectFileSize');
        get_filesize(this.medFile.filePath, action((size) => {
            console.log('set filesize', size);
            this.medFile.fileSize = size;
        }));
    }
}
__decorate([
    computed
], MedFileInfo.prototype, "derivedExtensionFromFilename", null);
__decorate([
    action.bound
], MedFileInfo.prototype, "detectFileSize", null);
function get_filesize(url, callback) {
    const xhr = new XMLHttpRequest();
    xhr.open('HEAD', url, true); // Notice "HEAD" instead of "GET",
    //  to get only the header
    xhr.onreadystatechange = function () {
        if (this.readyState === this.DONE) {
            callback(parseInt(xhr.getResponseHeader('Content-Length') || '0'));
        }
    };
    xhr.send();
}
